export interface FeatureTarget {
  projectId: string;
  featureCollectionId: number;
  featureId: number;
  sourceIds: string[];
}

type FeatureRef = Pick<FeatureTarget, 'projectId' | 'featureCollectionId' | 'featureId'>;

/** One fetch per feature, not per row: a property with four scenes in the cart is one round trip. */
export const featureTargetKey = (shape: FeatureRef) =>
  `${shape.projectId}:${shape.featureCollectionId}:${shape.featureId}`;

/**
 * A multispectral scene's thumbnail and preview come from its truecolor sibling, so the sibling's
 * source is fetched alongside it even when only the multispectral scene is in the cart.
 */
export function featureTargetsFor(
  shapes: readonly (FeatureRef & {sourceId: string})[]
): FeatureTarget[] {
  const byKey = new Map<string, FeatureTarget>();
  for (const shape of shapes) {
    const key = featureTargetKey(shape);
    let target = byKey.get(key);
    if (!target) {
      target = {
        projectId: shape.projectId,
        featureCollectionId: shape.featureCollectionId,
        featureId: shape.featureId,
        sourceIds: [],
      };
      byKey.set(key, target);
    }
    for (const sourceId of [shape.sourceId, shape.sourceId.replace('-MULTISPECTRAL', '')]) {
      if (!target.sourceIds.includes(sourceId)) {
        target.sourceIds.push(sourceId);
      }
    }
  }
  return [...byKey.values()];
}
